import { render, staticRenderFns } from "./SvgDefs.vue?vue&type=template&id=0844630f&"
import script from "./SvgDefs.vue?vue&type=script&lang=js&"
export * from "./SvgDefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports